import { render, staticRenderFns } from "./footView.vue?vue&type=template&id=3872dc99&scoped=true"
import script from "./footView.vue?vue&type=script&lang=js"
export * from "./footView.vue?vue&type=script&lang=js"
import style0 from "./footView.vue?vue&type=style&index=0&id=3872dc99&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3872dc99",
  null
  
)

export default component.exports